export default () => {
  const switcher = document.querySelector('.js-language-switcher')

  if (! switcher ) {
    return
  }

  switcher.addEventListener('click', function (e) {
    switcher.classList.toggle('active')
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/LanguageSwitcher.js